import 'twin.macro';

import { useContext, useEffect, useState } from 'react';

import iconJoystick from '../assets/svgs/joystick_white.svg';
import CircleSvgSpinner from '../components/CircleSvgSpinner';
import LoadingSpinner from '../components/LoadingSpinner';
import Spinner from '../components/Spinner';
import { UserContext } from '../contexts/UserContext';
import { useEagerConnect, useWeb3Listener } from '../hooks';
import AnyoneCanWinSection from './Home/AnyoneCanWinSection';
import CardWaveSection from './Home/CardWaveSection';
import EssaySection from './Home/EssaySection';
import HeroSection from './Home/HeroSection';
import LightTowerSection from './Home/LightTowerSection';

const Home = () => {
  useEagerConnect();
  useWeb3Listener();
  const { isLoading } = useContext(UserContext);
  const [showForm, setShowForm] = useState<boolean>(false);
  const [formLoading, setFormLoading] = useState<boolean>(false);

  useEffect(() => {
    if (showForm) {
      setFormLoading(true);
    }
  }, [showForm]);

  return (
    <>
      {isLoading ? (
        <div tw="fixed left-0 top-0 w-full h-full flex justify-center items-center bg-[#0006] z-40">
          <LoadingSpinner />
        </div>
      ) : null}
      <div
        css={isLoading ? { filter: 'blur(4px)' } : {}}
        tw="w-full min-h-[calc(100vh - 286px)]"
      >
        <HeroSection />
        <AnyoneCanWinSection />
        <CardWaveSection />
        <LightTowerSection
          handleClick={
            showForm
              ? () => {
                  return;
                }
              : () => setShowForm(true)
          }
        />
        <EssaySection />
      </div>
      <div
        css={{
          backgroundImage:
            'linear-gradient(0deg, #070215 0%, rgba(7, 2, 21, 0) 100%)',
        }}
        tw="fixed left-0 bottom-0 w-full h-[130px] flex justify-center items-end z-30"
      >
        <button
          tw="relative w-[250px] md:w-[418px] h-[55px] hover:opacity-75 transition-all duration-300"
          onClick={
            showForm
              ? () => {
                  return;
                }
              : () => setShowForm(true)
          }
        >
          <div tw="absolute left-0 top-0 w-full h-full z-30 skew-x-[15deg] origin-bottom-left overflow-hidden">
            <div tw="absolute left-0 top-0 w-full h-full bg-[#D2193A] skew-x-[-28deg] origin-bottom-left" />
          </div>
          <div tw="absolute left-0 top-0 w-full h-full flex justify-center items-center gap-4 md:gap-[25px] z-40">
            <span tw="text-[16px] leading-[23px] tracking-[0.22em]">
              ENTER NOW
            </span>
            <img alt="joystick" src={iconJoystick} width={18} />
          </div>
        </button>
      </div>
      {showForm && (
        <div
          css={showForm ? { backdropFilter: 'blur(12px)' } : {}}
          tw="px-5 pt-10 pb-2 fixed left-0 top-0 w-full h-full flex justify-center items-center bg-[#0002] transition-all z-50"
          onClick={() => setShowForm(false)}
        >
          {/* <Spinner open={formLoading} /> */}
          <CircleSvgSpinner open={formLoading} />
          <iframe
            className="popup-content"
            css={{
              display: formLoading ? 'none' : 'block',
              // filter: 'invert(1)',
            }}
            src="https://forms.gle/57kWmwshVuALzso17"
            title="Joystick's NFT Hunt"
            tw="w-full max-w-[580px] h-full max-h-[820px] bg-transparent rounded-lg"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onLoad={() => {
              setFormLoading(false);
            }}
          />
          <div tw="fixed left-1/2 top-2 translate-x-[-50%] text-[48px] text-[#fff6] cursor-pointer">
            &times;
          </div>
        </div>
      )}
    </>
  );
};

export default Home;
